export default __webpack_public_path__ + "images/consultorioDefault.4f0397eef988de27bd78739556730f69.jpg";